import { render, staticRenderFns } from "./headBar.vue?vue&type=template&id=2e852211&scoped=true&"
import script from "./headBar.vue?vue&type=script&lang=js&"
export * from "./headBar.vue?vue&type=script&lang=js&"
import style0 from "./headBar.vue?vue&type=style&index=0&id=2e852211&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../AppPlus/H5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e852211",
  null
  
)

export default component.exports